import {NavbarController} from './navbar.controller.js';
import template from './navbar.html';

const NavbarComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: NavbarController,
    controllerAs: 'vm',
    replace: true
};

export {NavbarComponent};



// WEBPACK FOOTER //
// ./app/components/common/navbar/navbar.component.js